import React, { useEffect, useState } from 'react';

import styles from './DogCardHealthOverview.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import StatusDot from '../../../../../Shared/StatusDot/StatusDot';
import HealthStatusRows from '../../../../../Shared/HealthStatusRows/HealthStatusRows';

function DogCardHealthOverview(props: DogCardHealthOverviewProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [dataHd, setHdData] = useState<any>();
    const [dataHdIndex, setHdIndexData] = useState<any>();
    const [dataGlaukom, setGlaukomData] = useState<any>();
    const [dataDwarf, setDwarfData] = useState<any>();
    const [dataAtaksi, setAtaksiData] = useState<any>();
    const [dataAd, setAdData] = useState<any>(undefined);

    function mapAdToStatusDot(ad: number | string) {
        if (props.statusDisabled) return null;
        switch (Number(ad)) {
            case 0: return <StatusDot color="#68db5a" size='md' />;
            case 1: return <StatusDot color="#ffe144" size='md' />;
            case 2: return <StatusDot color="#f89d27" size='md' />;
            case 3: return <StatusDot color="#ff2f45" size='md' />;
            default: return <StatusDot color="grey" size='md' />;
        }
    }

    function mapHdToStatusDot(hd: string) {
        if (props.statusDisabled) return null;
        switch (hd) {
            case "A": return <StatusDot color="#68db5a" size='md' />;
            case "B": return <StatusDot color="#a6f65d" size='md' />;
            case "C": return <StatusDot color="#ffe144" size='md' />;
            case "D": return <StatusDot color="#f89d27" size='md' />;
            case "E": return <StatusDot color="#ff2f45" size='md' />;
            default: return <StatusDot color="grey" size='md' />;
        }
    }

    function mapHdIndexToStatusDot(hdIndex: string) {
        if (props.statusDisabled) return null;
        if (hdIndex == "loading ..") return <StatusDot color="grey" size='md' />;

        if (typeof hdIndex == "string") return <StatusDot color="grey" size='md' />;
        if (hdIndex > 100) return <StatusDot color="#68db5a" size='md' />;
        if (hdIndex <= 100) return <StatusDot color="#ff2f45" size='md' />;
    }

    function mapGlaukomToStatusDot(glaukom: string) {
        if (props.statusDisabled) return null;
        switch (glaukom) {
            case "Fri": return <StatusDot color="#68db5a" size='md' />;
            case "Bærer": return <StatusDot color="#ff2f45" size='md' />;
            default: return <StatusDot color="grey" size='md' />;
        }
    }

    function mapDwarfToStatusDot(dwarf: string) {
        if (props.statusDisabled) return null;
        switch (dwarf) {
            case "Fri": return <StatusDot color="#68db5a" size='md' />;
            case "Bærer": return <StatusDot color="#ff2f45" size='md' />;
            default: return <StatusDot color="grey" size='md' />;
        }
    }

    function mapAtaksiToStatusDot(ataksi: string) {
        if (props.statusDisabled) return null;
        switch (ataksi) {
            case "Fri": return <StatusDot color="#68db5a" size='md' />;
            case "Bærer": return <StatusDot color="#ff2f45" size='md' />;
            default: return <StatusDot color="grey" size='md' />;
        }
    }
    
    function getHdData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/hd/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setHdData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }
    
    function getHdIndexData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/hdindex/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setHdIndexData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }
    
    function getGalukomData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/glaukom/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setGlaukomData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getDwarfData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/dwarf/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setDwarfData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getAtaksiData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/ataksi/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setAtaksiData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getAdData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/health/ad/latest",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setAdData(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getHdData();
            getHdIndexData();
            getGalukomData();
            getDwarfData();
            getAtaksiData();
            getAdData();
        }
    }, [props.dogId]);

    return (
        <div className={styles.healthoverview}>
            <Card
                title={props.title || "Health Overview"}
                children={<div>
                    <hr/>
                    <table className={styles.healthtable}>
                        <tbody>
                            { dataHd ?
                                <tr>
                                    <td><strong>{t("dog.statistics.hd.title")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataHd}</span>{mapHdToStatusDot(dataHd)}</td>
                                </tr>
                            : null }
                            { dataHdIndex ?
                                <tr>
                                    <td><strong>{t("dog.statistics.hdindex.title")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataHdIndex}</span>{mapHdIndexToStatusDot(dataHdIndex)}</td>
                                </tr>
                            : null }
                            { dataGlaukom ?
                                <tr>
                                    <td><strong>{t("dog.statistics.glaukom.title")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataGlaukom}</span>{mapGlaukomToStatusDot(dataGlaukom)}</td>
                                </tr>
                            : null }
                            { dataDwarf ?
                                <tr>
                                    <td><strong>{t("dog.statistics.dwarf.title")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataDwarf}</span>{mapDwarfToStatusDot(dataDwarf)}</td>
                                </tr>
                            : null }
                            { dataAtaksi ?
                                <tr>
                                    <td><strong>{t("dog.statistics.ataksi.title")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataAtaksi}</span>{mapAtaksiToStatusDot(dataAtaksi)}</td>
                                </tr>
                            : null }
                            { dataAd != null ?
                                <tr>
                                    <td><strong>{t("dog.statistics.ad.title")}:</strong></td>
                                    <td><span style={{marginRight: "6px"}}>{dataAd}</span>{mapAdToStatusDot(dataAd)}</td>
                                </tr>
                            : null }
                            <HealthStatusRows dogId={props.dogId} />
                        </tbody>
                    </table>
                </div>}
            ></Card>
        </div>
    );
}

class DogCardHealthOverviewProps {
    title?: string;
    dogId!: string | undefined;
    statusDisabled?: boolean;
    onDataLoaded?: (data: any) => void;
}

export default DogCardHealthOverview;